import React from 'react';
import './Helplines.css';
import Helpline from './Helplines.json';


export default class Helplines extends React.Component {
    constructor () {
      super();
      this.state = {
        activeCategory: "Europe"
      }
    }
  
    setCategory (category) {
      this.setState({ activeCategory: category });
    }
  
    render () {
      return (
        <div>
        <div className="buttons">
        <input className="button" type="radio" id="europe" name="btn" onChange={() => {this.setCategory('Europe')}}/>
        <label htmlFor="europe">Europe</label>
        <input className="button" type="radio" id="america"  name="btn" onChange={() => { this.setCategory('America') }} />
        <label htmlFor="america">USA</label>
        <input className="button" type="radio" id="other"  name="btn" onChange={() => { this.setCategory('Other') }} />
        <label htmlFor="other">Other</label>
      </div>


      
        <div className="helplinecontent">
            {Helpline.filter((helpline) => helpline.tag === this.state.activeCategory).map((Helpline,index) => {
            return <div  class="helpline"> <p class ="tag"> {Helpline.tag}</p><p class="helplinetext">{Helpline.name} <br/> {Helpline.number} <br/>{Helpline.openinghours} <br/> {Helpline.website} </p>
            </div>
        })}
        </div>
        </div>
  
  
    )
    }
  }